export const PATH = {
    root: '/',
    login: '/login',
    logout: '/logout',
    connect_logout: '/connect-logout',
    no_connection: '/no-connection',
    forbidden: '/forbidden',
    context: '/context',
    context_company: '/context/company',
    context_customer: '/context/customer',
    context_distributor: '/context/distributor',
    context_distributor_subscribers: '/context/distributor/subscribers',
    context_company_user_access: '/context/company/user-access',
    context_customer_user_access: '/context/customer/user-access',
    context_customer_on_premises_integrations: '/context/customer/on-premises-integrations',
    context_distributor_user_access: '/context/distributor/user-access',
    context_distributor_product: '/context/distributor/product',
    context_distributor_company_move: '/context/distributor/company-move',
    context_distributor_subscribers_user_access: '/context/distributor/subscribers/user-access',
    context_organization_user: '/context/organization/user',
    context_organization_company: '/context/organization/company',
    set_up_your_company: '/set-up-your-company',
    provisioning: '/provisioning'
}
